<script setup lang="ts">
import { MapPreset, Page } from '~/types/types'
import MapPresetsList from '~/components/MapPresetsList.vue'
const { find, findOne } = useStrapi()

useSeoMeta({
  title: () => `Drivmedla - Kartor och statistik`,
  description: () =>
    'Här finns kartor och statistik på både nationell och lokal nivå i flertalet olika kategorier som underlag för omställningnen.',
  ogTitle: () => `Drivmedla - Kartor och statistik`,
  ogDescription: () =>
    'Här finns kartor och statistik på både nationell och lokal nivå i flertalet olika kategorier som underlag för omställningnen.',
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})

const { data: pageInfo } = await useAsyncData(
  'maps-and-statistics-page',
  () => findOne<Page>('maps-and-statistics-page', { populate: '*' }),
  { transform: (_pageInfo) => _pageInfo.data }
)
</script>

<template>
  <main>
    <AppHero
      :title="pageInfo?.attributes.generalContent.title"
      :description="pageInfo?.attributes.generalContent.ingress"
      background-color="#6DA59B"
      color="#FFFFFF"
    />
    <LayoutSection>
      <MapPresetsList />
    </LayoutSection>
  </main>
</template>
